import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class Animations {
    constructor(){
        this.trigger = {
            case_studies: document.querySelectorAll('.case-studies-template-general'),
            contact_form_general: document.querySelectorAll('.contact-form-general-template-general'),
            how_work: document.querySelectorAll('.how-work-template-home'),
            cta_internal: document.querySelectorAll('.cta-internal-template-one'),
            icons_block: document.querySelectorAll('.icons-block-template-one'),
            text_generic:document.querySelectorAll('.text-generic-template-one'),
            text_img_alt: document.querySelectorAll('.text-img-alt-template-one'),
            blog: document.querySelectorAll('.container-single-post'),
            body: document.querySelector('body'),
            cta_general_internal: document.querySelectorAll('.cta-general-internal-template-about'),
            
        }
        this.animations = {
            case_studies_cube: document.querySelectorAll('.case-studies-template-general .animation-cube'),
            contact_form_general_cube: document.querySelectorAll('.contact-form-general-template-general .animation-cube'),
            how_work_cube: document.querySelectorAll('.how-work-template-home .animation-cube'),
            cta_internal_cube: document.querySelectorAll('.cta-internal-template-one .animation-cube'),
            icons_block_cube: document.querySelectorAll('.icons-block-template-one .animation-cube'),
            text_generic_cube: document.querySelectorAll('.text-generic-template-one .animation-cube'),
            text_img_alt_cube: document.querySelectorAll('.text-img-alt-cube-animations .animation-cube'),
            blog_cube: document.querySelectorAll('.container-single-post .animation-cube'),
            cta_general_internal_cube: document.querySelectorAll('.cta-general-internal-template-about .animation-cube'),
        }
    }

    init(){
        
        this.set();
        this.animation();
   
    }

    set = () => {

        //set blog cube 
        if (this.animations.blog_cube){
            gsap.set(this.animations.blog_cube, {
                y: '50%',
                autoAlpha:1
            })
        };

        //set text img alt cube
        if (this.animations.text_img_alt_cube){
            gsap.set(this.animations.text_img_alt_cube, {
                y: '50%',
                autoAlpha:1
            })
        };

        //set text generic
        if (this.animations.text_generic_cube){
            gsap.set(this.animations.text_generic_cube, {
                y: '50%',
                autoAlpha:1
            })
        };

        //set icons block cube
        if (this.animations.icons_block_cube){
            gsap.set(this.animations.icons_block_cube, {
                y: '50%',
                autoAlpha:1
            })
        };

        // set cta internal cube
        if (this.animations.cta_internal_cube){
            gsap.set(this.animations.cta_internal_cube, {
                y: '50%',
                autoAlpha:1
            })
        };

        //set how work cube
        if (this.animations.how_work_cube){
            gsap.set(this.animations.how_work_cube, {
                y: '50%',
                autoAlpha:1
            })
        };

        // set contact form general cube
        if (this.animations.contact_form_general_cube){
            gsap.set(this.animations.contact_form_general_cube, {
                y: '50%',
                autoAlpha:1
            })
        };

        // set case studies cube
        if (this.animations.case_studies_cube){
            gsap.set(this.animations.case_studies_cube, {
                y: '50%',
                autoAlpha:1
            })
        };

        // set cta general internal
        if (this.animations.cta_general_internal_cube){
            gsap.set(this.animations.cta_general_internal_cube, {
                y: '50%',
                autoAlpha:1
            })
        };
        
    }

    animation = () => {

        // animations cube blog 
        if (this.animations.blog_cube){
            gsap.to(this.animations.blog_cube, {
                y: '-80%',
                autoAlpha: 1,
                scrollTrigger: {
                    trigger: this.trigger.blog,
                    start: 'top top+=10%',
                    end: 'bottom center-=20%',
                    scrub: 1,
                    // once: true,
                    // markers: true, 
                }
            })
        };

        // animations cube text img alt
        if (this.animations.text_img_alt_cube){
            gsap.to(this.animations.text_img_alt_cube, {
                y: '0%',
                autoAlpha: 1,
                scrollTrigger: {
                    trigger: this.trigger.text_img_alt,
                    start: 'top+=10% center',
                    end: 'bottom-=10% center',
                    scrub: 1,
                    // once: true,
                    // markers: true, 
                }
            })
        };

        // animations cube text generic
        if (this.animations.text_generic_cube){
            gsap.to(this.animations.text_generic_cube, {
                y: '0%',
                autoAlpha: 1,
                scrollTrigger: {
                    trigger: this.trigger.text_generic,
                    start: 'top+=10% center',
                    end: 'bottom-=10% center',
                    scrub: 1,
                    // once: true,
                    // markers: true,
                }
            })
        };

        // animations cube icons block
        if (this.animations.icons_block_cube){
            gsap.to(this.animations.icons_block_cube, {
                y: '0%',
                autoAlpha: 1,
                scrollTrigger: {
                    trigger: this.trigger.icons_block,
                    start: 'top+=10% center',
                    end: 'bottom-=10% center',
                    scrub: 1,
                    // once: true,
                    // markers: true,
                }
            })
        };

        // animations cube cta internal 
        if (this.animations.cta_internal_cube){
            gsap.to(this.animations.cta_internal_cube, {
                y: '0%',
                autoAlpha: 1,
                scrollTrigger: {
                    trigger: this.trigger.cta_internal,
                    start: 'top+=10% center',
                    end: 'bottom-=10% center',
                    scrub: 1,
                    // once: true,
                    // markers: true,
                }
            })
        };

        // animations cube how work
        if (this.animations.how_work_cube){
            gsap.to(this.animations.how_work_cube, {
                y: '0%',
                autoAlpha: 1,
                scrollTrigger: {
                    trigger: this.trigger.how_work,
                    start: 'top+=10% center',
                    end: 'bottom-=10% center',
                    scrub: 1,
                    // once: true,
                    // markers: true,
                }
            })
        };

        // animations cube contact form general
        if (this.animations.contact_form_general_cube){
            gsap.to(this.animations.contact_form_general_cube, {
                y: '0%',
                autoAlpha: 1,
                scrollTrigger: {
                    trigger: this.trigger.contact_form_general,
                    start: 'top+=10% center',
                    end: 'bottom-=10% center',
                    scrub: 1,
                    // once: true,
                    // markers: true,
                }
            })
        };

        // animations cube case studies
        if (this.animations.case_studies_cube){
            gsap.to(this.animations.case_studies_cube, {
                y: '0%',
                autoAlpha: 1,
                scrollTrigger: {
                    trigger: this.trigger.case_studies,
                    start: 'top+=10% center',
                    end: 'bottom-=10% center',
                    scrub: 1,
                    // once: true,
                    // markers: true,
                }
            })
        };

        // animations cta general internal
        if (this.animations.cta_general_internal_cube){
            gsap.to(this.animations.cta_general_internal_cube, {
                y: '0%',
                autoAlpha: 1,
                scrollTrigger: {
                    trigger: this.trigger.cta_general_internal,
                    start: 'top+=10% center',
                    end: 'bottom-=10% center',
                    scrub: 1,
                    // once: true,
                    // markers: true,
                }
            })
        };
       
    }
}